export enum DealsMeasureEnum {
  consideration = 'consideration',
  inHouseGross = 'in_house_gross',
  agentNet = 'agent_net',
  companyNet = 'company_net',
}
